// Dependecies
import { createStore, createHook } from 'react-sweet-state';

const initialState = {
  history: [],
  message: '',
  profit: 0,
};

const actions = {
  getMaintenanceHistory:
    (dataFilter, token, locale) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'POST',
            body: JSON.stringify(dataFilter),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };
          const response = await fetch(
            `/api/bread/jwt/garage_workshops/static/filter_service_finalized?lang=${locale}`,
            options
          );
          const maintenanceHistory = await response.json();

          if (response.status !== 200) {
            reject(response);
          } else {
            if (maintenanceHistory.service_finalized.services.length > 0) {
              setState({ history: maintenanceHistory.service_finalized.services });
              setState({ profit: maintenanceHistory.profit });
            } else {
              setState({ history: [] });
              setState({ profit: 0 });
            }
            resolve(getState());
          }
        } catch (e) {
          reject(e);
        }
      }),
};

const Store = createStore({
  initialState,
  actions,
  name: 'maintenance_history',
});

export default createHook(Store);
